/**
 * Created by petule on 26.7.16.
 */
import { Device } from 'twilio-client'
const device = new Device

device.on('connect', function (conn) {
    console.log(conn)
    update_status("Phone phone is now connected.", "ready")
});

device.on('ready', function(device) {
    // The device is now ready
    update_status("Phone is now ready for connections.", "checking")
    console.log("Phone is now ready for connections");
});

device.on('offline', function() {
    console.log("offline")
    update_status("Phone is now offline.", "close")
});

device.on('cancel', function(conn) {
    console.log(conn.parameters.From); // who canceled the call
    console.log(conn.status());
    update_status("Phone is now closed.", "close")
});

device.on('disconnect', function (conn) {
    // Called for all disconnections
    console.log(conn.status());
    update_status("Phone is now disconnected", "close")
});

device.on('error', function (e) {
    $("#twilio-errors .text-error").append(e.message)
    $("#twilio-errors").show()
});

function clear_classes(){
    var status = $("#twilio-status .status");
    var status_text = $("#twilio-status .status-text")

    status.removeClass("icon-checking")
    status.removeClass("icon-ready")
    status.removeClass("icon-close")
    status_text.removeClass("ready")
    status_text.removeClass("checking")
    status_text.removeClass("close")
}

function update_status(message, status){
    var status_text = $("#twilio-status .status-text")

    clear_classes();
    $("#twilio-status .status").addClass("icon-"+status)
    status_text.addClass(status)
    status_text.html(message)
}
